<template>
  <div>
    <div
      id="itemd0cac130-3e05-11ec-a2e6-953464dcce14"
      :style="{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '18px',
        lineHeight: '1.5',
        color: '#ffffff',
        textAlign: 'center',
        textShadow: false ? '0px 0px 14px rgba(15, 146, 255,1)' : '',
        top:'30px'
      }"
      class="centertitle"
    >
      <p>简历投递情况</p>
    </div>
    
    <!-- 表格内容 -->
    <div id="item93b724c0-3e03-11ec-a2e6-953464dcce14">
      <table rules="none" class="projectNumTable">
        <thead>
          <tr>
            <th>序号</th>
            <th>企业名称</th>
            <th>投递数量</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in showData" :key="item.id || index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.total_deliveries }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="loading" style="color: white; text-align: center; padding: 20px;">
        加载中...
      </div>
    </div>
    
    <!-- 右下背景图开始-->
    <div id="item71b4b580-3deb-11ec-a2e6-953464dcce14">
      <img src="../../../assets/images/线框.png" alt="" :style="{ width: '100%', height: '100%' }" />
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import axios from 'axios';
import { baseURL } from '../../../api/base';

export default {
  mounted() {
    this.fetchData();
  },
  data() {
    return {
      showData: [],
      loading: true
    }
  },
  methods: {
    async fetchData() {
      try {
        console.log('开始请求数据...');
        const response = await axios.get(baseURL + '/api/getright3yl');
        
        console.log('接口返回数据:', response.data);
        
        // 直接使用接口返回的数据
        this.showData = response.data;
        
        console.log('设置到showData的数据:', this.showData);
        
      } catch (error) {
        console.error('请求失败:', error);
        // 出错时显示空数据
        this.showData = [];
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
#item71b4b580-3deb-11ec-a2e6-953464dcce14 {
  left: 20px;
  top:0px;
  width: 530px;
  height: 950px;
}
/* 标题位置 */
#item9c61daa0-3e05-11ec-a2e6-953464dcce14 {
  top: 14px;
}
#leftBottomShowWindow3 {
  position: absolute;
  left: 35px;
  top: 60px;
  width: 500px;
  height: 270px;
  overflow: hidden;
}
#leftBottomShowWindow3 .innerBox {
  display: flex;
  position: absolute;
  top: 0;
  left: -500px;
  height: 270px;
  width: 1350px;
}
#leftBottomShowWindow3 .innerBox div {
  position: absolute;
  top: 0px;
  width: 500px;
  height: 270px;
  z-index: 8;
  opacity: 1;
  transform: rotate(0deg);
  background: rgba(255, 255, 255, 0);
  border: 0px solid #2ed64a;
  border-radius: 0px;
  padding: 0px;
}
#leftBottomEchartsBox31 {
  left: 500px;
}
#leftBottomEchartsBox32 {
  left: 500px;
}
#leftBottomEchartsBox33 {
  left: 1000px;
}
.projectNumTable {
  width: 100%;
  height: 1.5rem;
  font-size: 16px;
  color: #fff;
}
#item93b724c0-3e03-11ec-a2e6-953464dcce14 {
  top: 100px;
}
.projectNumTable thead tr th:nth-child(1) {
  width: 60px;
}
.projectNumTable thead tr th:nth-child(2) {
  text-align: left;
}
.projectNumTable tbody tr td {
  text-align: center;
  height: 1.6rem;
}
.projectNumTable tbody tr td:nth-child(2) {
  text-align: left;
  height: 1.6rem;
}
.projectNumTable tbody tr {
  background: linear-gradient(to right, rgba(28, 103, 161, 1), rgba(28, 103, 161, 0.1));
}
.projectNumTable tbody tr:nth-child(2n) {
  background: linear-gradient(to right, rgba(4, 36, 94, 1), rgba(4, 36, 94, 0.1));
}
</style>
